require.context('./', false, /\.pug/);
require.context('./popovers', false, /\.pug/);
require.context('../common', true, /\.pug/);
require.context('../../src/settings', true, /\.pug/);  // Could not include this as a separate file in vizportal.ts and get it to compile correctly
